import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TITLES = { impressum: "Impressum", agb: "AGB", widerruf: "Widerrufsbelehrung", cookies: "Cookie-Richtlinie" };

export default function Legal({ type }) {
  const [c, setC] = useState({ name: "G-Repair", owner: "", street: "", zip: "", city: "", email: "info@g-repair.de", phone: "", ust_id: "", tax_number: "", kleinunternehmer: true });
  useEffect(() => { api.get("/company").then((r) => r.data && setC((p) => ({ ...p, ...r.data }))).catch(() => {}); }, []);

  const addr = `${c.owner}, ${c.street}, ${c.zip} ${c.city}`;
  const showAddr = !!c.show_address_impressum;
  const blocks = {
    impressum: [
      ["Angaben gemäß § 5 TMG", `${c.name}\n${c.owner}${showAddr ? `\n${c.street}\n${c.zip} ${c.city}` : ""}`],
      ["Kontakt", `E-Mail: ${c.email}${c.phone ? `\nTelefon: ${c.phone}` : ""}`],
      ["Umsatzsteuer", c.kleinunternehmer ? "Als Kleinunternehmer im Sinne von § 19 UStG wird keine Umsatzsteuer berechnet." : `USt-IdNr.: ${c.ust_id || "—"}${c.tax_number ? `\nSteuernummer: ${c.tax_number}` : ""}`],
      ...(showAddr ? [["Verantwortlich i.S.d. § 55 Abs. 2 RStV", addr]] : []),
    ],
    agb: [
      ["1. Geltungsbereich", `Diese AGB gelten für alle Reparaturaufträge zwischen ${c.name} (${addr}) und dem Kunden im Einsendeverfahren.`],
      ["2. Auftrag & Preise", "Mit Absenden der Bestellung erteilt der Kunde einen kostenpflichtigen Reparaturauftrag zum angezeigten Festpreis zzgl. Versand. Preise verstehen sich " + (c.kleinunternehmer ? "ohne Ausweis von Umsatzsteuer (§ 19 UStG)." : "inkl. gesetzlicher MwSt.")],
      ["3. Ablauf", "Der Kunde sendet das Gerät ein. Nach Reparatur wird es versichert zurückgesendet. Die Bearbeitung dauert i. d. R. 1–3 Werktage."],
      ["4. Gewährleistung", "Auf Display-Reparaturen mit Original-OLED-Display gewähren wir eine zusätzliche Garantie von 6 Monaten auf Teile und Arbeit. Bei LCD-Displays besteht diese zusätzliche Garantie nicht. Der Akkutausch ist von der zusätzlichen Garantie ausgenommen, da es sich bei Akkus um Verschleißteile handelt. Die gesetzlichen Gewährleistungsrechte des Kunden bleiben hiervon unberührt."],
      ["5. Haftung", "Für Datenverluste wird keine Haftung übernommen. Der Kunde ist für die Sicherung seiner Daten selbst verantwortlich."],
    ],
    widerruf: [
      ["Widerrufsrecht", "Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Frist beginnt mit Vertragsschluss."],
      ["Ausübung", `Zum Widerruf informieren Sie uns (${c.name}, ${addr}, ${c.email}) mittels einer eindeutigen Erklärung (z. B. E-Mail).`],
      ["Erlöschen", "Das Widerrufsrecht erlischt vorzeitig, wenn die Reparatur auf ausdrücklichen Wunsch bereits vollständig ausgeführt wurde."],
      ["Folgen", "Im Falle eines wirksamen Widerrufs erstatten wir bereits geleistete Zahlungen unverzüglich zurück."],
    ],
    cookies: [
      ["Cookies", "Diese Website verwendet ausschließlich technisch notwendige Cookies bzw. lokalen Speicher, die für den Betrieb der Seite erforderlich sind."],
      ["Keine Tracking-Cookies", "Es werden keine Marketing- oder Analyse-Cookies von Drittanbietern ohne Ihre Einwilligung gesetzt."],
      ["Verwaltung", "Sie können Cookies jederzeit in Ihren Browser-Einstellungen löschen oder blockieren."],
    ],
  };

  return (
    <section data-testid={`legal-${type}`} className="relative z-10 bg-[#050505] py-16 lg:py-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <h1 className="font-display text-white text-4xl sm:text-5xl mb-10">{TITLES[type]}</h1>
        <div className="space-y-8">
          {(blocks[type] || []).map(([h, body]) => (
            <div key={h}>
              <h2 className="font-display text-2xl text-white mb-2">{h}</h2>
              <p className="text-[#aaa] leading-relaxed whitespace-pre-line">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
